import React, { useEffect } from 'react';
import './Loading.css';

const Loading = () => {
  useEffect(() => {
    const grid = document.getElementById('grid');
    const size = 29;

    // Predefined pattern map
    const patternMap = [
      // Define fixed positions for tetrominoes and solid blacks
      // 1: position pattern
      // 2: alignment pattern
      // 3: tetromino-i
      // 4: tetromino-j
      // 5: tetromino-l
      // 6: tetromino-o
      // 7: tetromino-s
      // 8: tetromino-t
      // 9: tetromino-z
      // Adding 10 to any number (13-19) means it should be solid black
    ];

    function isPositionPattern(row, col) {
      const patternSize = 7;
      const isTopLeft = row < patternSize && col < patternSize;
      const isTopRight = row < patternSize && col >= size - patternSize;
      const isBottomLeft = row >= size - patternSize && col < patternSize;

      if (isTopLeft || isTopRight || isBottomLeft) {
        const isOuter = row === 0 || row === 6 ||
                        row === size-7 || row === size-1 ||
                        col === 0 || col === 6 ||
                        col === size-7 || col === size-1;
        const isInner = (row >= 2 && row <= 4 && col >= 2 && col <= 4) ||
                        (row >= 2 && row <= 4 && col >= size-5 && col <= size-3) ||
                        (row >= size-5 && row <= size-3 && col >= 2 && col <= 4);

        return isOuter || isInner;
      }
      return false;
    }

    function isNearPattern(row, col) {
      const patternSize = 7;
      const nearTopLeft = row < patternSize + 0 && col < patternSize + 0;
      const nearTopRight = row < patternSize + 0 && col >= size - patternSize - 0;
      const nearBottomLeft = row >= size - patternSize - 0 && col < patternSize + 0;
      const alignmentRow = Math.floor(size * 0.77);
      const alignmentCol = Math.floor(size * 0.77);
      const nearAlignment = Math.abs(row - alignmentRow) <= 2 && Math.abs(col - alignmentCol) <= 2;

      return (nearTopLeft || nearTopRight || nearBottomLeft || nearAlignment) && 
         !isPositionPattern(row, col) && !isAlignmentPattern(row, col);
    }

    function isAlignmentPattern(row, col) {
        const alignmentRow = Math.floor(size * 0.77);
        const alignmentCol = Math.floor(size * 0.77);
        
        return (
          (Math.abs(row - alignmentRow) <= 2 && Math.abs(col - alignmentCol) <= 2 && (
            row === alignmentRow-2 || row === alignmentRow+2 ||
            col === alignmentCol-2 || col === alignmentCol+2
          )) ||
          (Math.abs(row - alignmentRow) <= 1 && Math.abs(col - alignmentCol) <= 1 && (
            (row === alignmentRow && col === alignmentCol)
          ))
        );
      }
    
    let seed = 123459;
    let randomState = seed;

    function seededRandom() {
        randomState = (1103515245 * randomState + 12345) % 2147483647;
        return randomState / 2147483647;
    }

    const tetrominoes = ['i', 'j', 'l', 'o', 's', 't', 'z'];
    let tetroGroup = Array(size).fill().map(() => Array(size).fill(null));

    function createGrid() {
      for (let row = 0; row < size; row++) {
        for (let col = 0; col < size; col++) {
          const div = document.createElement('div');
          div.className = 'loading_grid-item';
          
          if (isPositionPattern(row, col)) {
            div.classList.add('loading_position-pattern');
          } else if (isAlignmentPattern(row, col)) {
            div.classList.add('loading_alignment-pattern');
          } else if (isNearPattern(row, col)) {
            div.classList.add('loading_near-pattern');
          } else {
            div.classList.add('loading_tetromino');
            
            let nearbyType = null;
            if (row > 0 && tetroGroup[row-1][col]) nearbyType = tetroGroup[row-1][col];
            else if (col > 0 && tetroGroup[row][col-1]) nearbyType = tetroGroup[row][col-1];
            
            const tetroType = nearbyType || tetrominoes[Math.floor(seededRandom() * tetrominoes.length)];
            tetroGroup[row][col] = tetroType;
            div.classList.add(`loading_tetromino-${tetroType}`);
            
            // Use seeded random for consistent solid black patterns
            if (seededRandom() < 0.55) {
              div.classList.add('loading_tetromino-solid');
            }
          }
          
          div.style.setProperty('--delay', seededRandom() * 10);

          div.addEventListener('click', function() {
            document.querySelectorAll('.loading_grid-item').forEach(item => {
              item.classList.remove('active');
            });
            this.classList.add('active');
          });

          grid.appendChild(div);
        }
      }
    }

    if (grid) {
      createGrid();
    }
  }, []);

  return (
    <div className="loading-container">
      <div className="loading_overlay">
        <div className="loading_scanner-container">
          <div className="loading_qr-code">
            <div className="loading_corner loading_corner-tl"></div>
            <div className="loading_corner loading_corner-tr"></div>
            <div className="loading_corner loading_corner-bl"></div>
            <div className="loading_corner loading_corner-br"></div>
            <div className="loading_scan-line"></div>
            <div className="loading_grid" id="grid"></div>
          </div>
          <div className="loading_text">
            Por favor aguarde<span className="loading_dots">...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;